import { useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { api } from "../lib/api";
import { AuthCard } from "../components/auth/AuthCard";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await api.post("/auth/forgot-password", { email }).catch(() => {});
    setBusy(false);
    setDone(true);
  };

  return (
    <AuthCard title={t("auth.forgotTitle")} subtitle={t("auth.forgotSub")} testId="forgot-password-card">
      {done ? (
        <p className="mt-6 rounded-xl bg-brand/10 px-4 py-3 text-sm text-navy" data-testid="forgot-password-done">{t("auth.forgotDone")}</p>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("login.email")} data-testid="forgot-password-email"
            className="h-12 w-full rounded-xl border border-slate-200 px-4 text-base text-navy outline-none focus:border-brand focus:ring-4 focus:ring-brand/15" />
          <button type="submit" disabled={busy} data-testid="forgot-password-submit" className="h-12 w-full rounded-xl bg-brand text-base font-semibold text-white hover:bg-[#25a065] disabled:opacity-60">{t("auth.sendLink")}</button>
        </form>
      )}
      <Link to="/login" className="mt-5 block text-center text-sm font-medium text-brand" data-testid="back-to-login">{t("auth.backToLogin")}</Link>
    </AuthCard>
  );
}
